import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { Button, SelectRaw } from '../../../../components';

const AddAddendumModal = ({ isOpen, onClose, addendumTypes, onSave }) => {
	const [selectedAddendumType, setSelectedAddendumType] = useState('');
	const [addendum, setAddendum] = useState('');

	useEffect(() =>  {
		if (!isOpen) {
			setSelectedAddendumType(Array.isArray(addendumTypes) ? addendumTypes[0] : '');
			setAddendum('');
		}
	}, [isOpen]);

	const handleSave = () => {
		onSave({
			addendumType: selectedAddendumType,
			addendum
		});
	};

	return (
		<Modal isOpen={isOpen} contentLabel="Add Addendum" className="modal-dialog">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							Add Addendum
						</h3>
					</div>
				</div>
				<div className="modal-body form-horizontal">
					<div className="form-group">
						<label className="col-lg-4 control-label">Type</label>
						<div className="col-lg-8">
							<SelectRaw
								options={addendumTypes}
								selectedValue={selectedAddendumType}
								onChange={({ target }) => setSelectedAddendumType(target.value)}
							/>
						</div>
					</div>
					<div className="form-group">
						<label className="col-lg-4 control-label">Addendum</label>
						<div className="col-lg-8">
							<textarea
								className="form-control"
								value={addendum}
								onChange={({ target }) => setAddendum(target.value)}
								rows={10}
							/>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<Button
						title="Cancel"
						onClick={onClose}
					/>
					<Button
						primary
						title="Save Addendum"
						onClick={handleSave}
					/>
				</div>
			</div>
		</Modal>
	);
};

AddAddendumModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	addendumTypes: PropTypes.array,
	onSave: PropTypes.func.isRequired,
};

export default AddAddendumModal;
